import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=79d0be66&"
import script from "./AddToCartButton.vue?vue&type=script&lang=ts&"
export * from "./AddToCartButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports